import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional } from "@/__main__/data-model.mjs";
import { cardBrandModel } from "@/feature-wallet/models/card-brand.mjs";
import { paymentProviderTypeModel } from "@/feature-wallet/models/payment-method-provider.mjs";

const paymentIntentModel = {
  paymentMethodCardBrand: Optional(cardBrandModel),
  paymentMethodCardLast4: Optional(String),
} satisfies ModelDefinition;

export interface UserTransactionPaymentIntent
  extends FromModel<typeof paymentIntentModel> {}

export const userTransactionModel = {
  currency: String,

  amountDue: Number,
  amountPaid: Number,
  tax: Number,

  createdAt: Date,
  receiptNumber: Optional(String),
  chargedAt: Optional(Date),

  isAttempted: Boolean,
  isPaid: Boolean,

  providerType: paymentProviderTypeModel,

  paymentIntent: paymentIntentModel,

  items: [
    {
      amount: Number,
      subscriptionId: String,
      currency: String,
    },
  ],

  paymentMethodId: String,
  subscriptionId: Optional(String),
} satisfies ModelDefinition;

export interface UserTransaction
  extends FromModel<typeof userTransactionModel> {}

export const UserTransactionsModel = createModel({
  data: { userPaymentInfo: { paymentInvoices: [userTransactionModel] } },
}).transform(
  [userTransactionModel],
  (data) => data.data.userPaymentInfo.paymentInvoices,
);
